import { amexCardSupport, type Country } from '../../entities/Country';

export const checkAmexSupported = (country: Country): boolean =>
  amexCardSupport.includes(country);

export const checkSupportedCards = (country: Country) => {
  const supportedCards = ['visa', 'mastercard'];
  const isAmexSupported = checkAmexSupported(country);
  if (isAmexSupported) {
    supportedCards.push('amex');
  }
  return supportedCards;
};
